// extracted by mini-css-extract-plugin
export default {"selfRating":"styles__selfRating___X3681"};